import ModelFactory from '../model-factory';

import BaseModel from '../models/base-model';

export default class Cache extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.message = data || null;
  }
}

export const modelFactory = new ModelFactory('cache', (data) => new Cache(data));
